export { default } from "ember-stereo/helpers/fastforward-sound";
